<template>
    <div class="imc_inbox_table" id="i_table">
        <b-skeleton-table v-if="!is_load" :rows=this.cur_records :columns="2" :hide-header=true :table-props="{ bordered: false, striped: true }"></b-skeleton-table>
        
        <div class="inbox_vue_list" v-if="is_load">

            <b-table  :thead-class="head_class" :tbody-tr-class="rowClass" striped class="table-responsive-xl resolution_table" :items="rows" :fields="fields">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Працюэмо...</strong>
                        </div>
                    </template>

                    <!-- header fields -->
                    <template v-slot:head(id)="data">
                        <div class="custom-control custom-checkbox">
                            <input
                                    v-model="is_check_all"
                                    type="checkbox"
                                    v-on:click="check_all"
                                    class="custom-control-input"
                                    id="imc_checker_all" />
                            <label class="custom-control-label cursor-pointer bolder" for="imc_checker_all"></label>
                        </div>
                    </template>

                    <template v-slot:head(number)="data">
                        <grid_id  list_ordering="m.id" field_name="№" ></grid_id>
                    </template>

                    <template v-slot:head(added)="data">
                        <grid_id  list_ordering="m.added" field_name="Дата" ></grid_id>
                    </template>

                    <template v-slot:head(quest_name)="data">
                        <grid_id  list_ordering="q_real.title" field_name="Питання" ></grid_id>
                    </template>

                    <template v-slot:head(small_tov_title)="data">
                        <grid_id  list_ordering="t.title" field_name="Органiзацiя" ></grid_id>
                    </template>

                    <template v-slot:head(init_name)="data">
                        <grid_id list_ordering="m.init_user" field_name="Ініціатор" ></grid_id>
                    </template>

                    <template v-slot:head(rec_short_name)="data">
                        <grid_id  list_ordering="m.recipient_id" field_name="Затвердження" ></grid_id>
                    </template>

                    <template v-slot:head(isp_name)="data">
                        <grid_id  list_ordering="m.isp_id" field_name="Виконавець" ></grid_id>
                    </template>

                    <template v-slot:head(date_to)="data">
                        <grid_id  list_ordering="	h_sort.end_work" field_name="Дата до" ></grid_id>
                    </template>

                    <template  v-slot:head(count_unread_chat)="data">
                        <span class="fs-xl text-center" v-html="data.label"></span>
                    </template>

                    <!-- body draw -->
                    <template  v-slot:cell(id)="data">
                        <div class="custom-control custom-checkbox">
                            <input
                                    v-model="data.item._is_checked"
                                    :value="data.item.id"
                                    :name="'cid[]'"
                                    type="checkbox"
                                    class="custom-control-input"
                                    :id="data.item.id + '_cust_id'" />

                            <label class="custom-control-label cursor-pointer bolder" :for="data.item.id + '_cust_id'"></label>
                        </div>
                    </template>

                    <template  v-slot:cell(code)="data">
                        <div class='icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer' v-on:click="load_preview(data.item.id,data)">
                            <i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
                            <i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
                        </div>
                    </template>

                    <template  v-slot:cell(number)="data">
                      <a class="mem_link" :href="data.item.link" >
                        <span v-html="nice_search(data.item.tov_code + '_' + data.item.code+'_'+data.item.id)"></span>
                      </a>

                        <span class="hidden-md-down" v-if="data.item.files > 0">
                           <span class="files_cont show_inside_files cursor-pointer" v-on:click="load_preview_files(data.item.id,data)">
                               <i class="fa fa-paperclip" aria-hidden="true"></i>
                           </span>
                        </span>

                        <div class="hidden-lg-up small">
                            {{data.item.added_format}}
                        </div>
                    </template>

                    <template  v-slot:cell(added)="data">
                        {{data.item.added_format}}
                    </template>

                    <template  v-slot:cell(quest_name)="data">
                        <a class="mem_link" :href="data.item.link" >
                            <span v-html="nice_search(data.item.quest_name )"></span>
                        </a>
                        <div>
                            <span class=" fw-300 fs-sm mt-2">
                                <i>
                                    <span v-html="nice_search(data.item.title  )"></span>
                                </i>
                            </span>
                        </div>
                    </template>

                    <template  v-slot:cell(small_tov_title)="data">
                        <div class='icon-stack fs-xl mr-2'>
                            <i class="fal fa-building icon-stack-3x opacity-100 color-primary-500"></i>
                        </div>
                            {{data.item.small_tov_title}}

                        <div>
                            <div class='icon-stack fs-xl mr-2' >
                                <i class="fal fa-address-card icon-stack-3x opacity-40 color-primary-500"></i>
                            </div>
                            {{data.item.serv_title}}
                        </div>
                    </template>

                    <template  v-slot:cell(date_to)="data">
                        <span v-html="data.item.date_to"></span>
                    </template>

                    <template  v-slot:cell(can_pdf)="data">
                        <a class="pdf_link" target="_blank" :href="data.item.pdf_link" v-if="is_can_pdf">
                            <div class='icon-stack fs-xxl' >
                                <i class="base base-19 icon-stack-3x opacity-100 color-primary-900"></i>
                                <i class="fal fa-file-pdf icon-stack-1x opacity-100 color-white"></i>
                            </div>
                        </a>
                        <span v-else>-</span>
                    </template>

                    <template  v-slot:cell(count_unread_chat)="data">
                        <div class='icon-stack fs-xxl'>
                            <i class="base base-6 icon-stack-3x opacity-100 color-primary-900"></i>
                            <i class="fal fa-bell icon-stack-1x opacity-100 color-white"></i>
                            <span class="badge badge-icon">
                                {{data.item.count_unread_chat}}
                            </span>
                        </div>
                    </template>

                    <template  v-slot:cell(favorite_class)="data">
                        <div class="icon-stack set_favorite fs-xxl cursor-pointer" v-on:click="set_favorite(data.item)">
                            <i class="base base-19 icon-stack-3x opacity-100 color-primary-900"></i>
                            <i  :class="{'color-danger-100' : data.item.is_favorite, 'color-white' : !data.item.is_favorite}" class="fas  fa-star icon-stack-1x " ></i>
                        </div>
                    </template>

                    <template  v-slot:cell(remove_class)="data">
                        <div class='icon-stack rem_doc' :class="{'disable' : data.item.can_remove === false}" v-on:click="remove_doc(data.item)">
                            <i class="base base-1 icon-stack-3x opacity-100 color-danger-600"></i>
                            <i class="far fa-trash-alt icon-stack-1x opacity-100 color-white"></i>
                        </div>
                    </template>

                    <template v-slot:row-details="row">
                        <fast_preview :item="row.item.fast_preview" v-if="row.item._showFastPreview"></fast_preview>
                        <fast_files :files="row.item.fast_files_preview" v-if="row.item._showFastFilePreview"></fast_files>
                    </template>


            </b-table>

            <div class="inb_pagi pt-4" >
                <imc_filter_pagination pagi_url="index.php?option=com_imc_docs&task=inbox.getPagination"></imc_filter_pagination>
            </div>
        </div>

    </div>
</template>

<script>

    import fast_preview from "./preview/fast_preview";
    import Fast_files from "./preview/fast_files";
    import Grid_id from "./grid/index";
    import imc_filter_pagination from "./pagination/pagination.vue";


    import {createHelpers} from 'vuex-map-fields';

    const {mapFields} = createHelpers({
        getterType: 'inbox_state/getInboxStateField',
        mutationType: 'inbox_state/updateInboxStateField',
    });

    export default {
        name: "inbox_table",

        components : {
            Grid_id,
            Fast_files,
            fast_preview,
            imc_filter_pagination
        },
        props: {
            current_state: {
                type: Object
            },

            can_pdf : {
                type : Boolean,
                default : false
            }
        },

        created() {
            EventBus.$on("inbox_change_state",this.inbox_change_state);
            EventBus.$on("inbox_reload_items",this.load_items);

            EventBus.$on("search_inbox_called",this.search_work);
            EventBus.$on("clean_inbox_filter",this.clean_inbox_filter);


            EventBus.$on("auto_action_called",this.auto_action_called);
            EventBus.$on("land_xls_called",this.land_xls_called);

            EventBus.$on("filter_select_change",this.filter_select)

        },

        data() {
            return {
                rows : [],
                is_load:false,
                is_check_all : false,

                is_filter_work : false,


                active_items : [],
                fields : [
                    {
                        key : 'id',
                        label: '',
                        class:'text-center hidden-md-down'
                    },
                    {
                        key : 'code',
                        label: '',
                        class:'hidden-md-down'
                    },

                    {
                        key : 'number',
                        label: 'm.id',
                        class:'tender_pre_name'
                    },
                    {
                        key : 'added',
                        label: 'm.added',
                        class:'text-center hidden-md-down'
                    },
                    {
                        key : 'quest_name',
                        label: 'q_real.title',
                        class:' '
                    },
                    {
                        key : 'small_tov_title',
                        label: 't.title',
                        class:' hidden-md-down'
                    },

                    {
                        key : 'init_name',
                        label: 'm.init_user',
                        class:' hidden-md-down'
                    },
                    {
                        key : 'rec_short_name',
                        label: 'm.recipient_id',
                        class:' hidden-md-down'
                    },
                    {
                        key : 'isp_name',
                        label: 'm.isp_id',
                        class:' hidden-md-down'
                    },
                    {
                        key : 'date_to',
                        label: 'h_sort.end_work',
                        class:' hidden-md-down'
                    },
                    {
                        key : 'can_pdf',
                        label: 'PDF',
                        class:' hidden-md-down'
                    },
                    {
                        key : 'count_unread_chat',
                        label: ' <i class="fa fa-comments" aria-hidden="true"></i>',
                        class:' hidden-md-down'
                    },
                    {
                        key : 'favorite_class',
                        label: ' ',
                        class:' hidden-md-down'
                    },
                    {
                        key : 'remove_class',
                        label: ' ',
                        class:' text-center fs-xxl cursor-pointer'
                    },
                ],
            }
        },

        mounted() {
            this.$store.dispatch('inbox_state/LOAD_STATES',this.current_state);
        },

        methods: {

            filter_select(res) {

                if (myapp_config.debugState) {
                    console.log("%c|___MEMORANDUM LIST select", "color: #fd3995", res);
                }
                this.send_list.limit_start = 0;
                this.filter[res.type] = res.value;

                this.inbox_change_state({
                    type: "filter_select"
                });

            },

            nice_search(str) {
                if (!this.filter.hasOwnProperty('search')) {
                    return str;
                }
                return str.replace(new RegExp(this.filter.search, "gi"), match => {
                    return '<span class="text-danger">' + match + '</span>';
                });

            },

            auto_action_called() {
                let self = this;
                if (this.checked_items_id.length > 0) {
                    const is_ok = confirm_imc('Виконати ?');
                    is_ok.then(res => {
                        self.$store.dispatch('memorandum_inside/AUTO_ACTION',self.checked_items_id);
                    });
                } else {
                    EventBus.$emit('show_toast', {
                        err: "Нічого не обрано",
                        type: "danger",
                        title: "Автоматична Дія помилка"
                    })
                }
            },

            land_xls_called() {
                IMC_CORE.showloading();
                if (this.checked_items_id.length > 0) {
                    const is_ok = confirm_imc('Вигрузити в файл дані '+this.checked_items_id.length+' службових ?');
                    is_ok.then(res => {
                        api.post("/memorandums/land/excel", {'ids' : this.checked_items_id}).then(({data}) => {
                            this.is_load = true;
                            IMC_CORE.hideloading();
                            if(data.status == "operation_success") {
                                let url = data.data;
                                window.open(url, '_blank');
                                
                            }
                        }).catch(err => {
                            IMC_CORE.hideloading();
                            this.rows = [];
                            EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                            this.is_load = false;
                        });
                    });
                } else {
                    IMC_CORE.hideloading();
                    EventBus.$emit('show_toast', {
                        err: "Нічого не обрано",
                        type: "danger",
                        title: "Земля XLS помилка"
                    })
                }
            },



            clean_inbox_filter() {

                this.send_list.limit_start = 0;
                this.filter.search = "";

                this.send_list.direction = "DESC";
                this.send_list.ordering = "m.added";

                let self = this;
                Object.keys(this.all_filter).map(name => {
                    self.filter[name] = "";
                });

                this.inbox_change_state({
                    type: "search_called",
                    force_reload: false,
                });


            },

            search_work(search_str) {
                if (myapp_config.debugState) {
                    console.log("%c|___MEMORANDUM LIST search", "color: #fd3995", search_str);
                }

                this.send_list.limit_start = 0;
                this.filter.search = search_str;

                this.inbox_change_state({
                    type: "search_called"
                });
            },


            async load_items() {
                
                await axios.post("/docs/internal/inbox/memorandums", this.send_state).then(({data}) => {
                    this.is_load = true;
                    this.rows = [];
                    if (data.status === "operation_success") {
                        this.rows = data.data;
                        this.$store.dispatch('inbox_state/LOAD_PAGINATION', data.message.pagination);
                    }
                }).catch(err => {
                    this.rows = [];
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                    this.is_load = false;
                });
            },

            scroll_top() {
                let options = {
                    container: 'body',
                    easing: 'ease-in',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function (element) {
                        // scrolling started
                    },
                    onDone: function (element) {
                        // scrolling is done
                    },
                    onCancel: function () {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                this.$scrollTo('#js-page-content', 1600, options)
            },

            async inbox_change_state(state_field) {
                this.is_load = false;
                if (myapp_config.debugState) {
                    console.log("%c|___MEMORANDUM LIST change State...", "color: #fd3995", state_field);
                }
                
                let send = {
                    filter: this.filter,
                    doc_type: this.doc_type,
                    inbox_list: this.send_list
                };
                console.log("%c|___MEMORANDUM LIST State Send", "color: #fd3995", send);

                await axios.post("/docs/internal/inbox/setNewModelState", {
                    "list_filter" : send
                }).then(({data}) => {
                    if (data.status === "operation_success") {
                        if (state_field.hasOwnProperty("force_reload")) {
                            window.location.reload();
                        } else {

                            let res = data.message;
                            if (res.hasOwnProperty("arr_state")) {
                                //dispatch will refresh items
                                this.$store.dispatch('inbox_state/LOAD_STATES', res.arr_state);
                                //   this.scroll_top();
                                EventBus.$emit("reload_mem_count");
                            }
                        }
                    }
                }).catch(err => {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                });

            },

            check_all() {
                this.rows.map(item => {
                    item._is_checked = !this.is_check_all;
                })
            },
            
            async remove_doc(mem) {
                if (mem.can_remove) {
                    let self = this;
                    const is_ok = confirm_imc('Видалити ?');
                    is_ok.then(res => {
                        api.delete("/memorandums/" + mem.id).then(({data}) => {
                            if (data.status === "operation_success") {
                                let upd_rows = [];
                                self.rows.map(ins => {
                                    if (ins.id !== mem.id) {
                                        upd_rows.push(ins);
                                    }
                                });
                                self.rows = upd_rows;
                                EventBus.$emit("reload_mem_count");
                            }
                        }).catch(err => {
                            EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                        });
                    });
                }
            },

            async load_preview(mem_id, row) {
                row.item._showFastFilePreview = false;
                row.fast_files_preview = null;

                if (!row.item._showFastPreview) {

                    await api.get('/memorandums/' + mem_id + '/preview',).then(({data}) => {
                        if (data.status == "operation_success") {
                            row.item.fast_preview = data.data;
                            row.item._showFastPreview = true;
                            row.item._showDetails = true;
                        }
                    }).catch(err => {
                        row.item._showFastPreview = false;
                        row.item._showDetails = false;
                        row.fast_preview = null;
                    });
                } else {
                    row.item._showDetails = false;
                    row.item._showFastPreview = false;
                    row.fast_preview = null;
                }
            },

            async load_preview_files(mem_id, row) {

                row.item._showFastPreview = false;
                row.fast_preview = null;

                if (!row.item._showFastFilePreview) {
                    await api.get('/memorandums/' + mem_id + "/files",).then(({data}) => {
                        if (data.status == "operation_success") {
                            row.item.fast_files_preview = data.data;
                            row.item._showFastFilePreview = true;
                            row.item._showDetails = true;
                        }
                    }).catch(err => {
                        row.item._showFastFilePreview = false;
                        row.fast_files_preview = null;

                        row.item._showDetails = false;
                    });
                } else {
                    row.item._showDetails = false;
                    row.item._showFastFilePreview = false;
                    row.fast_files_preview = null;
                }
            },


            async set_favorite(row) {
                await api.patch('/memorandums/'+row.id+'/favorite').then(({data}) => {
                    if(data.status == "operation_success") {
                        row.is_favorite = !row.is_favorite;
                        EventBus.$emit("reload_mem_count");
                    }
                }).catch(err => {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                });
            },

            rowClass(item) {
                if (!item) return;
                return item.class;
            }
        },
        computed: {

            ...mapFields([
                'list',
                'filter',
                'doc_type',
                'send_list',
                'all_filter'
            ]),

            checked_items () {
                return this.rows.filter(item => {
                    return item._is_checked === true;
                })
            },

            checked_items_id () {
                let arr_id = [];
                this.checked_items.map(item => {
                    arr_id.push(item.id);
                });

                return arr_id;
            },

            is_can_pdf () {
                return this.can_pdf;
            },

            head_class() {
                // if(!this.show_head) {
               // return 'hidden_header';
                // }
            },
            cur_records() {
                if (this.current_state !== undefined) {
                    return 50;
                }
                return 30;
            },

            send_state() {
                if (this.current_state !== undefined) {
                    delete this.current_state.task;
                    delete this.current_state.all_filter;
                    delete this.current_state.list;
                    delete this.current_state.filter;


                    return this.current_state;
                }
            },
        }
    }
</script>

<style scoped>

    .disable {
        opacity: 0.2;
    }
    .highlightText {
        background: yellow;
    }
</style>
